import { render, staticRenderFns } from "./DirectoryEmployeeItemView.vue?vue&type=template&id=765aff7b"
import script from "./DirectoryEmployeeItemView.vue?vue&type=script&lang=js"
export * from "./DirectoryEmployeeItemView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports